import { render } from "./ProjectImages.vue?vue&type=template&id=c085c67e"
import script from "./ProjectImages.vue?vue&type=script&lang=js"
export * from "./ProjectImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__